export const CONTACT_EMAIL = 'contato@orbdigital.com.br'

export const CONTACT_PHONE_DISPLAY = '+55 (11) 95427-7059'

export const CONTACT_LOCATION = 'São Paulo, Brasil'

export const WHATSAPP_NUMBER = '5511954277059'

export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}`
